export const InfoColumns = [
	{ columnId: "n", label: "Nº", width: "100" },
	{ columnId: "employeeCode", label: "Employee ID", width: "150" },
	{ columnId: "employeeName", label: "Employee Name", textAlign: "left", width: "200" },
];

export const contactTable = [
	{ columnId: "n", label: "Nº", width: "100", align:"center" },
	{ columnId: "nameInKH", label: "Name In KH", width: "100", align:"center" },
	{ columnId: "nameInEN", label: "Name In EN", width: "100", align:"center" },
	{ columnId: "link", label: "Link", width: "100", align:"center" },
	{ columnId: "createdBy", label: "Created By", width: "200", align:"center" },
	{ columnId: "modifiedBy", label: "Modified By", width: "200", align:"center" },
];

export const nationalityTable = [
	{ columnId: "n", label: "Nº", width: "100", align:"center" },
	{ columnId: "region", label: "Region", width: "100", align:"center" },
	{ columnId: "nameInKH", label: "Name In KH", width: "100", align:"center" },
	{ columnId: "nameInEN", label: "Name In EN", width: "100", align:"center" },
	{ columnId: "createdBy", label: "Created By", width: "200", align:"center" },
	{ columnId: "modifiedBy", label: "Modified By", width: "200", align:"center" },
];

export const fullBorderExcel = {
	borderLeft: 2,
	borderRight: 2,
	borderTop: 2,
	borderBottom: 2,
};

// --------- ticket sales table -------------
export const ticketSalesColumn = [
  { columnId: "date", label: "Date.", textAlign: "center", w: "120px", readOnly: true },
  { columnId: "tourist1Day", label: "T1D.", textAlign: "center", w: "80px", type: "number" },
  { columnId: "tourist3Days", label: "T3D.", textAlign: "center", w: "80px", type: "number" },
  { columnId: "tourist7Days", label: "T7D.", textAlign: "center", w: "80px", type: "number" },
  { columnId: "totalTourist", label: "T TOTAL.", textAlign: "center", w: "80px", readOnly: true },

  { columnId: "revenue1Day", label: "R1D.", textAlign: "center", w: "80px", readOnly: true },
  { columnId: "revenue3Days", label: "R3D.", textAlign: "center", w: "80px", readOnly: true },
  { columnId: "revenue7Days", label: "R7D.", textAlign: "center", w: "80px", readOnly: true },
  { columnId: "totalTouristRevenue", label: "R TOTAL", textAlign: "center", w: "80px", readOnly: true },

  { columnId: "touristOnline1Day", label: "TO1D", textAlign: "center", w: "80px", type: "number" },
  { columnId: "touristOnline3Days", label: "T03D", textAlign: "center", w: "80px", type: "number" },
  { columnId: "touristOnline7Days", label: "T07D", textAlign: "center", w: "80px", type: "number" },
  { columnId: "totalTouristOnline", label: "TO TOTAL", textAlign: "center", w: "80px", readOnly: true },
  { columnId: "totalTouristOnlineRevenue", label: "RO TOTAL", textAlign: "center", w: "80px", readOnly: true },

  { columnId: "touristLongPass100", label: "TL100", textAlign: "center", w: "80px", type: "number" },
  { columnId: "touristLongPass150", label: "TL150", textAlign: "center", w: "80px", type: "number" },
  { columnId: "touristLongPass200", label: "TL200", textAlign: "center", w: "80px", type: "number" },
  { columnId: "totalTouristLongPass", label: "TO TOTAL5", textAlign: "center", w: "80px", readOnly: true },
  { columnId: "totalTouristLongPassRevenue", label: "RO TOTAL6", textAlign: "center", w: "80px", readOnly: true },
];
export const ticketSalesExcelColumn = [
  { columnId: "dateExcel", label: "Date.", textAlign: "center", w: "120px", readOnly: true },
  { columnId: "tourist1Day", label: "T1D.", textAlign: "center", w: "80px", type: "number" },
  { columnId: "tourist3Days", label: "T3D.", textAlign: "center", w: "80px", type: "number" },
  { columnId: "tourist7Days", label: "T7D.", textAlign: "center", w: "80px", type: "number" },
  { columnId: "totalTourist", label: "T TOTAL.", textAlign: "center", w: "80px", readOnly: true },

  { columnId: "revenue1Day", label: "R1D.", textAlign: "center", w: "80px", readOnly: true },
  { columnId: "revenue3Days", label: "R3D.", textAlign: "center", w: "80px", readOnly: true },
  { columnId: "revenue7Days", label: "R7D.", textAlign: "center", w: "80px", readOnly: true },
  { columnId: "totalTouristRevenue", label: "R TOTAL", textAlign: "center", w: "80px", readOnly: true },

  { columnId: "touristOnline1Day", label: "TO1D", textAlign: "center", w: "80px", type: "number" },
  { columnId: "touristOnline3Days", label: "T03D", textAlign: "center", w: "80px", type: "number" },
  { columnId: "touristOnline7Days", label: "T07D", textAlign: "center", w: "80px", type: "number" },
  { columnId: "totalTouristOnline", label: "TO TOTAL", textAlign: "center", w: "80px", readOnly: true },
  { columnId: "totalTouristOnlineRevenue", label: "RO TOTAL", textAlign: "center", w: "80px", readOnly: true },

  { columnId: "touristLongPass100", label: "TL100", textAlign: "center", w: "80px", type: "number" },
  { columnId: "touristLongPass150", label: "TL150", textAlign: "center", w: "80px", type: "number" },
  { columnId: "touristLongPass200", label: "TL200", textAlign: "center", w: "80px", type: "number" },
  { columnId: "totalTouristLongPass", label: "TO TOTAL5", textAlign: "center", w: "80px", readOnly: true },
  { columnId: "totalTouristLongPassRevenue", label: "RO TOTAL6", textAlign: "center", w: "80px", readOnly: true },
];
export const ticketSalesColumnInput = [
	{ columnId: "tourist1Day", label: "T1D.", textAlign: "center", w: "80px", type:"number" },
	{ columnId: "tourist3Days", label: "T3D.", textAlign: "center", w: "80px", type:"number"},
	{ columnId: "tourist7Days", label: "T7D.", textAlign: "center", w: "80px", type:"number" },

	{ columnId: "touristOnline1Day", label: "TO1D", textAlign: "center", w: "80px", type:"number" },
	{ columnId: "touristOnline3Days", label: "T03D", textAlign: "center", w: "80px", type:"number" },
	{ columnId: "touristOnline7Days", label: "T07D", textAlign: "center", w: "80px", type:"number" },

	{ columnId: "touristLongPass100", label: "TL100", textAlign: "center", w: "80px", type:"number" },
	{ columnId: "touristLongPass150", label: "TL150", textAlign: "center", w: "80px", type:"number" },
	{ columnId: "touristLongPass200", label: "TL200", textAlign: "center", w: "80px", type:"number" },
]

export const touristByAgentColumn = [
	{ columnId: "n", label: "No.", textAlign: "center", w: "80px", readOnly: true },
	{ columnId: "tourAgent", label: "TOUR AGENT", textAlign: "center", w: "160px", readOnly: true },
	{ columnId: "teenager1DayTicket", label: "T1D", textAlign: "center", w: "80px", type:"number" },
	{ columnId: "adult1DayTicket", label: "A1D.", textAlign: "center", w: "80px", type:"number"},
	{ columnId: "pensioner1DayTicket", label: "P1D.", textAlign: "center", w: "80px", type:"number" },
	{ columnId: "teenager3DaysTicket", label: "T3D.", textAlign: "center", w: "80px", type:"number" },

	{ columnId: "adult3DaysTicket", label: "A3D.", textAlign: "center", w: "80px", type:"number", },
	{ columnId: "pensioner3DaysTicket", label: "P3D.", textAlign: "center", w: "80px", type:"number", },
	{ columnId: "teenager7DaysTicket", label: "T7D.", textAlign: "center", w: "80px", type:"number", },
	{ columnId: "adult7DaysTicket", label: "A7D", textAlign: "center", w: "80px", type:"number" },

	{ columnId: "pensioner7DaysTicket", label: "P7D", textAlign: "center", w: "80px", type:"number" },
	{ columnId: "totalTeenagerTicket", label: "ALL T", textAlign: "center", w: "80px",  readOnly: true },
	{ columnId: "totalAdultTicket", label: "ALL A", textAlign: "center", w: "80px",  readOnly: true },
	{ columnId: "totalPensionerTicket", label: "ALL P", textAlign: "center", w: "80px", readOnly: true },
	{ columnId: "totalAllAge", label: "ALL AGE", textAlign: "center", w: "80px", readOnly: true },
];

export const touristByAgentColumnInput = [
	{ columnId: "teenager1DayTicket", label: "T1D", textAlign: "center", w: "80px", type:"number" },
	{ columnId: "adult1DayTicket", label: "A1D.", textAlign: "center", w: "80px", type:"number"},
	{ columnId: "pensioner1DayTicket", label: "P1D.", textAlign: "center", w: "80px", type:"number" },

	{ columnId: "teenager3DaysTicket", label: "T3D.", textAlign: "center", w: "80px", type:"number" },
	{ columnId: "adult3DaysTicket", label: "A3D.", textAlign: "center", w: "80px", type:"number", },
	{ columnId: "pensioner3DaysTicket", label: "P3D.", textAlign: "center", w: "80px", type:"number", },

	{ columnId: "teenager7DaysTicket", label: "T7D.", textAlign: "center", w: "80px", type:"number", },
	{ columnId: "adult7DaysTicket", label: "A7D", textAlign: "center", w: "80px", type:"number" },
	{ columnId: "pensioner7DaysTicket", label: "P7D", textAlign: "center", w: "80px", type:"number" },
];

export const touristByNationalityColumn = [
	{ columnId: "n", label: "No.", textAlign: "center", w: "60px", readOnly: true },
	{ columnId: "dateFormat", label: "DATE", textAlign: "center", w: "60px", readOnly: true },
	{ columnId: "nationalityName", label: "COUNTRY", textAlign: "left", w: "120px", readOnly: true },
	{ columnId: "underAge12", label: "Under Age 12", textAlign: "center", w: "80px", type:"number" },
	{ columnId: "age12To25", label: "Age 12 - 25", textAlign: "center", w: "80px", type:"number"},
	{ columnId: "age26To59", label: "Age 26 - 59", textAlign: "center", w: "80px", type:"number" },
	{ columnId: "age60Up", label: "Age 60 Up", textAlign: "center", w: "80px", type:"number" },
	{ columnId: "totalAge", label: "Total Age", textAlign: "center", w: "80px", readOnly: true },

	{ columnId: "female", label: "FEMALE", textAlign: "center", w: "80px", type:"number", },
	{ columnId: "male", label: "MALE", textAlign: "center", w: "80px", type:"number", },
	{ columnId: "totalGender", label: "TOTAL GENDER", textAlign: "center", w: "80px", readOnly: true },
];

export const touristByNationalityColumnInput = [
	{ columnId: "underAge12", label: "Under Age 12", textAlign: "center", w: "80px", type:"number"},
	{ columnId: "age12To25", label: "Age 12 - 25", textAlign: "center", w: "80px", type:"number" },
	{ columnId: "age26To59", label: "Age 26 - 59", textAlign: "center", w: "80px", type:"number" },
	{ columnId: "age60Up", label: "Age 60 Up", textAlign: "center", w: "80px", type:"number" },

	{ columnId: "female", label: "FEMALE", textAlign: "center", w: "80px", type:"number" },
	{ columnId: "male", label: "MALE", textAlign: "center", w: "80px", type:"number" },
	
]

export const touristEachTempleColumn = [
	{ columnId: "n", label: "No.", textAlign: "center", w: "120px", readOnly: true },
	{ columnId: "date", label: "Date", textAlign: "center", w: "120px", readOnly: true },
	{ columnId: "hour", label: "Hour", textAlign: "center", w: "80px", readOnly: true },
	{ columnId: "nationality", label: "NATIONALITY", textAlign: "center", w: "80px", readOnly: true},
	{ columnId: "angkorWatWest", label: "ANGKOR WAT WEST", textAlign: "center", w: "80px", type:"number" },
	{ columnId: "angkorWatEast", label: "ANGKOR WAT EAST", textAlign: "center", w: "80px", type:"number" },
	{ columnId: "bakheng", label: "BAKHENG", textAlign: "center", w: "80px", type:"number" },
	{ columnId: "bayonWest", label: "BAYON WEST", textAlign: "center", w: "80px", type:"number" },
	{ columnId: "bayonEast", label: "BAYON EAST", textAlign: "center", w: "80px", type:"number" },
	{ columnId: "bayonNorth", label: "BAYON NORTH", textAlign: "center", w: "80px", type:"number" },
	{ columnId: "bayonSouth", label: "BAYON SOUTH", textAlign: "center", w: "80px", type:"number" },
	{ columnId: "taProhmWest", label: "TA PROHM WEST", textAlign: "center", w: "80px", type:"number" },
	{ columnId: "taProhmEast", label: "TA PROHM EAST", textAlign: "center", w: "80px", type:"number" },
	{ columnId: "taProhmNorth", label: "TA PROHM NORTH", textAlign: "center", w: "80px", type:"number" },
	{ columnId: "banteayKdeiWest", label: "BANTEAY KDEI WEST", textAlign: "center", w: "80px", type:"number" },
	{ columnId: "banteayKdeiEast", label: "BANTEAY KDEI EAST", textAlign: "center", w: "80px", type:"number" },
	{ columnId: "kravan", label: "KRAVAN", textAlign: "center", w: "80px", type:"number" },
	{ columnId: "taNei", label: "TA NEI", textAlign: "center", w: "80px", type:"number" },
	{ columnId: "takeo", label: "TAKEO", textAlign: "center", w: "80px", type:"number" },
	{ columnId: "preahKhanWest", label: "PREAH KHAN WEST", textAlign: "center", w: "80px", type:"number" },
	{ columnId: "preahKhanEast", label: "PREAH KHAN EAST", textAlign: "center", w: "80px", type:"number" },
	{ columnId: "preahKhanNorth", label: "PREAH KHAN NORTH", textAlign: "center", w: "80px", type:"number" },
	{ columnId: "neakPean", label: "NEAK PEAN", textAlign: "center", w: "80px", type:"number" },
	{ columnId: "taSom", label: "TA SOM", textAlign: "center", w: "80px", type:"number" },
	{ columnId: "preRupEast", label: "PRE RUP EAST", textAlign: "center", w: "80px", type:"number" },
	{ columnId: "preRupSouth", label: "PRE RUP SOUTH", textAlign: "center", w: "80px", type:"number" },
	{ columnId: "mebon", label: "MEBON", textAlign: "center", w: "80px", type:"number" },
	{ columnId: "banteaySamre", label: "BAN TEAY SAMRE", textAlign: "center", w: "80px", type:"number" },
	{ columnId: "bakongWest", label: "BAKONG WEST", textAlign: "center", w: "80px", type:"number" },
	{ columnId: "bakongEast", label: "BAKONG EAST", textAlign: "center", w: "80px", type:"number" },
	{ columnId: "lolei", label: "LOLEI", textAlign: "center", w: "80px", type:"number" },
	{ columnId: "preahKo", label: "PREAH KO", textAlign: "center", w: "80px", type:"number" },
	{ columnId: "banteaySrei", label: "BANTEAY SREI", textAlign: "center", w: "80px", type:"number" },
	{ columnId: "kbalSpean", label: "KBAL SPEAN", textAlign: "center", w: "80px", type:"number" },
	{ columnId: "phnomKrom", label: "PHNOM KROM", textAlign: "center", w: "80px", type:"number" },
	{ columnId: "watAthwea", label: "WAT ATHWEA", textAlign: "center", w: "80px", type:"number" },
	{ columnId: "bengMealea", label: "BENG MEALEA", textAlign: "center", w: "80px", type:"number" },
];

export const touristEachTempleColumnInput = [
	{ columnId: "angkorWatWest", label: "ANGKOR WAT WEST", textAlign: "center", w: "80px", type:"number" },
	{ columnId: "angkorWatEast", label: "ANGKOR WAT EAST", textAlign: "center", w: "80px", type:"number" },
	{ columnId: "bakheng", label: "BAKHENG", textAlign: "center", w: "80px", type:"number" },
	{ columnId: "bayonWest", label: "BAYON WEST", textAlign: "center", w: "80px", type:"number" },
	{ columnId: "bayonEast", label: "BAYON EAST", textAlign: "center", w: "80px", type:"number" },
	{ columnId: "bayonNorth", label: "BAYON NORTH", textAlign: "center", w: "80px", type:"number" },
	{ columnId: "bayonSouth", label: "BAYON SOUTH", textAlign: "center", w: "80px", type:"number" },
	{ columnId: "taProhmWest", label: "TA PROHM WEST", textAlign: "center", w: "80px", type:"number" },
	{ columnId: "taProhmEast", label: "TA PROHM EAST", textAlign: "center", w: "80px", type:"number" },
	{ columnId: "taProhmNorth", label: "TA PROHM NORTH", textAlign: "center", w: "80px", type:"number" },
	{ columnId: "banteayKdeiWest", label: "BANTEAY KDEI WEST", textAlign: "center", w: "80px", type:"number" },
	{ columnId: "banteayKdeiEast", label: "BANTEAY KDEI EAST", textAlign: "center", w: "80px", type:"number" },
	{ columnId: "kravan", label: "KRAVAN", textAlign: "center", w: "80px", type:"number" },
	{ columnId: "taNei", label: "TA NEI", textAlign: "center", w: "80px", type:"number" },
	{ columnId: "takeo", label: "TAKEO", textAlign: "center", w: "80px", type:"number" },
	{ columnId: "preahKhanWest", label: "PREAH KHAN WEST", textAlign: "center", w: "80px", type:"number" },
	{ columnId: "preahKhanEast", label: "PREAH KHAN EAST", textAlign: "center", w: "80px", type:"number" },
	{ columnId: "preahKhanNorth", label: "PREAH KHAN NORTH", textAlign: "center", w: "80px", type:"number" },
	{ columnId: "neakPean", label: "NEAK PEAN", textAlign: "center", w: "80px", type:"number" },
	{ columnId: "taSom", label: "TA SOM", textAlign: "center", w: "80px", type:"number" },
	{ columnId: "preRupEast", label: "PRE RUP EAST", textAlign: "center", w: "80px", type:"number" },
	{ columnId: "preRupSouth", label: "PRE RUP SOUTH", textAlign: "center", w: "80px", type:"number" },
	{ columnId: "mebon", label: "MEBON", textAlign: "center", w: "80px", type:"number" },
	{ columnId: "banteaySamre", label: "BAN TEAY SAMRE", textAlign: "center", w: "80px", type:"number" },
	{ columnId: "bakongWest", label: "BAKONG WEST", textAlign: "center", w: "80px", type:"number" },
	{ columnId: "bakongEast", label: "BAKONG EAST", textAlign: "center", w: "80px", type:"number" },
	{ columnId: "lolei", label: "LOLEI", textAlign: "center", w: "80px", type:"number" },
	{ columnId: "preahKo", label: "PREAH KO", textAlign: "center", w: "80px", type:"number" },
	{ columnId: "banteaySrei", label: "BANTEAY SREI", textAlign: "center", w: "80px", type:"number" },
	{ columnId: "kbalSpean", label: "KBAL SPEAN", textAlign: "center", w: "80px", type:"number" },
	{ columnId: "phnomKrom", label: "PHNOM KROM", textAlign: "center", w: "80px", type:"number" },
	{ columnId: "watAthwea", label: "WAT ATHWEA", textAlign: "center", w: "80px", type:"number" },
	{ columnId: "bengMealea", label: "BENG MEALEA", textAlign: "center", w: "80px", type:"number" },
];

export const feedbackTable = [
	{ columnId: "n", label: "Nº", width: "100", align:"center" },
	{ columnId: "templeName", label: "Temple Name", width: "200", align:"center" },
	{ columnId: "typeOfFeedbackName", label: "Type", width: "200", align:"center" },
	{ columnId: "description", label: "Description", width: "600", align:"start" },
	{ columnId: "dateExcel", label: "Date", width: "200", align:"center" }
];

export const profileNationalVisitorTable = [
	{ columnId: "n", label: "Nº", width: "50", align:"center" },
	{ columnId: "provinceName", label: "Province", width: "200", align:"start" },
	{ columnId: "people", label: "People", width: "120", align:"center" },
	{ columnId: "under12Year", label: "Under 12 Year", width: "120", align:"center" },
	{ columnId: "age12To25", label: "Age 12 to 25", width: "120", align:"center" },
	{ columnId: "age26To59", label: "Age 26 to 59", width: "120", align:"center" },
	{ columnId: "age60AndUp", label: "Age 60 and Up", width: "120", align:"center" },
	{ columnId: "durationName", label: "Duration", width: "120", align:"center" },
	{ columnId: "zoneName", label: "Zone", width: "120", align:"start" },
	{ columnId: "purposeOfVisitName", label: "Purpose Of Visit", width: "120", align:"start" },
	{ columnId: "transportationName", label: "Transportation", width: "120", align:"start" },
	{ columnId: "dateExcel", label: "Date Scan", width: "150", align:"center" },
];
